/**
 * 아이온 - 레기온
 */
import { Fragment } from 'react';
import { numberWithCommas } from '@utils/index';
import type { ILegion, ISetLegion, l10nType } from '@type/index';

export const setLegionItem = (item: ILegion): ISetLegion | null => {
  return item && typeof item === 'object'
    ? {
        ...item,
        url: `/legions/server/${item?.serverId}/id/${item?.legionId}/home`,
        point: numberWithCommas(item?.point),
      }
    : null;
};

const LegionArticle = ({ item, l10n }: { item: ILegion; l10n: l10nType }) => {
  const data = setLegionItem(item);

  if (!data) {
    return <Fragment />;
  }

  const { raceId, legionName, url, serverName, raceName, level, point, memberCount } = data;
  return (
    <div className="search-item-content">
      <div className={`search-item-logo ${raceId ? 'asmodian' : 'elyos'}`}>
        <figure></figure>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={url} dangerouslySetInnerHTML={{ __html: legionName }}></a>
        </div>
        <div className="search-item-info">
          <span>{serverName}</span>
          <span>{raceName}</span>
          <span>Lv. {level}</span>
        </div>
        <div className="search-item-info">
          <span>
            {l10n?.template?.legionPoint} : {point}{' '}
          </span>
          <span>
            {l10n?.template?.total} {memberCount}
            {l10n?.template?.memberCount}
          </span>
        </div>
      </div>
    </div>
  );
};

export default LegionArticle;
